import axios from 'axios'
import { reactive } from 'vue'
import { getApiUrl } from '@/config/api'
import authService from '@/services/auth'

const BASE = '/api/Pendientes'
const REFRESCO_MS = 5 * 60 * 1000
const ESPERA_MINIMA_MS = 15 * 1000

// Estado compartido: lo leen el menú, la barra superior y la pantalla de "Mis pendientes"
export const pendientesState = reactive({
  total: 0,
  porTipoDoc: {},
  grupos: [],
  cargando: false,
  cargado: false
})

let ultimaCarga = 0
let temporizador = null

function vaciar() {
  pendientesState.total = 0
  pendientesState.porTipoDoc = {}
  pendientesState.grupos = []
  pendientesState.cargado = false
}

export async function refrescarPendientes(forzar = false) {
  if (!authService.isAuthenticated() || !authService.getSelectedEmpresa()) {
    vaciar()
    return
  }
  if (pendientesState.cargando) return
  if (!forzar && Date.now() - ultimaCarga < ESPERA_MINIMA_MS) return

  pendientesState.cargando = true
  try {
    const r = await axios.post(getApiUrl(`${BASE}/mios`), {})
    const d = r?.data || {}
    pendientesState.total = Number(d.Total || 0)
    pendientesState.porTipoDoc = d.PorTipoDoc || {}
    pendientesState.grupos = Array.isArray(d.Grupos) ? d.Grupos : []
    pendientesState.cargado = true
    ultimaCarga = Date.now()
  } catch (e) {
    console.warn('No se pudieron cargar los pendientes', e)
  } finally {
    pendientesState.cargando = false
  }
}

export function iniciarRefrescoPendientes() {
  detenerRefrescoPendientes()
  refrescarPendientes(true)
  temporizador = setInterval(() => refrescarPendientes(true), REFRESCO_MS)
}

// Al cambiar de pantalla: arranca el refresco periódico si no estaba y vuelve a consultar (con espera mínima)
export function asegurarRefrescoPendientes() {
  if (!authService.isAuthenticated()) {
    detenerRefrescoPendientes()
    return
  }
  if (!temporizador) {
    iniciarRefrescoPendientes()
    return
  }
  refrescarPendientes()
}

export function detenerRefrescoPendientes() {
  if (temporizador) clearInterval(temporizador)
  temporizador = null
  vaciar()
}

export function pendientesDeTipoDoc(tipoDoc) {
  return Number(pendientesState.porTipoDoc?.[String(tipoDoc || '').toUpperCase()] || 0)
}
